import { render, staticRenderFns } from "./StoreSelector.vue?vue&type=template&id=5b5ff4ad&scoped=true"
import script from "./StoreSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./StoreSelector.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./StoreSelector.vue?vue&type=style&index=0&id=5b5ff4ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5ff4ad",
  null
  
)

export default component.exports